import axiosInstance from "../axiosInstance";

import {
	FETCH_SHIPPERS_REQUEST,
	FETCH_SHIPPERS_SUCCESS,
	FETCH_SHIPPERS_FAIL,
	EXPORT_SHIPPERS_REQUEST,
	EXPORT_SHIPPERS_SUCCESS,
	EXPORT_SHIPPERS_FAIL,
} from "../constants/shipper";

const fetchShippers = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	let url = null;
	if (params) {
		if (params.filter) {
			let filterParams = handleFilterParams(params.filter);
			url = `/admin/shipper?page=${params.start}&count=${
				params.count
			}&${filterParams.join("&")}`;
		} else {
			url = `/admin/shipper?page=${params.start}&count=${params.count}`;
		}
	} else {
		url = "/admin/shipper";
	}
	dispatch({ type: FETCH_SHIPPERS_REQUEST });
	try {
		const { data } = await axiosInstance.get(url, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SHIPPERS_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SHIPPERS_FAIL, payload: errorMessage });
	}
};

const exportShippers = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	let url = null;
	if (params && params.filter) {
		let filterParams = handleFilterParams(params.filter);
		url = `/admin/shipper/export?${filterParams.join("&")}`;
	} else {
		url = `/admin/shipper/export`;
	}
	dispatch({ type: EXPORT_SHIPPERS_REQUEST });
	try {
		const { data } = await axiosInstance.get(url, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: EXPORT_SHIPPERS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: EXPORT_SHIPPERS_FAIL, payload: errorMessage });
	}
};

const handleFilterParams = (params) => {
	let result = [];
	for (let item of Object.keys(params)) {
		if (params[item]) {
			result.push(`filter[${item}]=${params[item]}`);
		}
	}
	return result;
};

export { fetchShippers, exportShippers };
